module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="form-group">\n    <label class="DescartesUILabel"> Projection: WGS84 - Lonlat </label>\n</div>\n<div class="form-group">\n    <label class="DescartesUILabel">' +
((__t = (labelText)) == null ? '' : __t) +
'</label>\n	<select class="DescartesUISelect form-control" name="format" id="format">\n		';
 for (var i = 0, len = listExportFormat.length; i < len; i++) { ;
__p += '\n			<option value="' +
((__t = (listExportFormat[i].id)) == null ? '' : __t) +
'">' +
((__t = (listExportFormat[i].label)) == null ? '' : __t) +
'</option>\n		';
};
__p += '\n	</select>\n</div>';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/DMap/Button/ContentTask/bootstrap4/templates/ExportVectorLayer.ejs
// module id = 143
// module chunks = 0